export default "__VITE_ASSET__CSM5jaf2__"